import { CRouteParamsError } from "@/composables/use-route-params/route-params-error.types";

export function assertProgramBelongsToSite<TProgram extends { siteId: number }>(
  program: TProgram,
  siteId: number,
): TProgram {
  if (program.siteId !== siteId) throw new CRouteParamsError("programId");

  return program;
}
